import {Component, Input, OnChanges, OnInit} from '@angular/core';
import {MenuItem} from 'primeng/primeng';
import {COIService} from '../../services';
import {ActivatedRoute, ParamMap} from '@angular/router';
import {environment} from '../../../../environments/environment';

@Component({
  selector: 'app-menu-bar',
  templateUrl: './menu-bar.component.html',
  styleUrls: ['./menu-bar.component.scss']
})
export class MenuBarComponent implements OnInit, OnChanges {

  items: MenuItem[];
  styleClass: string;
  accountId: number;
  showMenuBar: boolean = true;
  _isMobileMenu: boolean;
  environment = environment;

  @Input()
  get isMobileMenu() {
    return this._isMobileMenu;
  }

  set isMobileMenu(mobileMenu) {
    let needLoadItems = false;
    if (this._isMobileMenu !== mobileMenu) {
      needLoadItems = true;
    }
    this._isMobileMenu = mobileMenu;
    this.styleClass = this.isMobileMenu ? 'ui-menubar--mobile' : '';
    if (needLoadItems) {
      this.loadItems();
    }
  }

  constructor(private coiService: COIService, private route: ActivatedRoute) {
  }

  ngOnChanges() {
    this.showMenuBar = !!(this.coiService.isUtilityUser() || (this.coiService.isBusinessUser() && this.coiService.isApprovedUser()));
    this.styleClass = this.isMobileMenu ? 'ui-menubar--mobile' : '';
  }

  ngOnInit() {
    this.route.queryParamMap.subscribe((queryParams: ParamMap) => {
      if (queryParams.get('account_id')) {
        this.accountId = +queryParams.get('account_id');
      } else {
        delete this.accountId;
      }
      this.loadItems();
    });
    this.loadItems();
  }

  loadItems() {
    let items = [];
    if (this.coiService.isUtilityUser()) {
      items = [
        {
          label: 'Dashboard',
          routerLink: ['dashboard'],
          routerLinkActiveOptions: '[\'router-link-active\']'
        }];
      if (this.coiService.isTecoTenant() || this.coiService.isNypaTenant()) {
        items.push({
          label: 'Asset Registry',
          routerLink: ['asset-registry'],
          queryParams: {program: 1},
          routerLinkActiveOptions: '[\'router-link-active\']'
        });
      } else {
        items.push({
          label: 'Asset Registry',
          routerLink: ['asset-registry'],
          routerLinkActiveOptions: '[\'router-link-active\']'
        });
      }
      items.push({
        label: 'Demand Response',
        items: [
          {
            label: 'Asset Registry',
            icon: 'fa fa-fw fa-list',
            routerLink: ['asset-registry'],
            routerLinkActiveOptions: '[\'router-link-active\']',
            queryParams: {program: 1}
          },
          {
            label: 'Events',
            icon: 'fa fa-fw fa-calendar',
            routerLink: ['demand-response/events'],
            routerLinkActiveOptions: '[\'router-link-active\']'
          },
          {
            label: 'Carbon Reduction',
            icon: 'fa fa-fw fa-cloud',
            routerLink: ['demand-response/carbon-reduction'],
            routerLinkActiveOptions: '[\'router-link-active\']'
          },
          {
            label: 'Performance Graph',
            icon: 'fa fa-fw fa-line-chart',
            routerLink: ['demand-response/performance-graph'],
            routerLinkActiveOptions: '[\'router-link-active\']'
          },
          {
            label: 'Registered Capacity',
            icon: 'fa fa-fw fa-bolt',
            routerLink: ['demand-response/registered-capacity'],
            routerLinkActiveOptions: '[\'router-link-active\']'
          },
          {
            label: 'Reports',
            icon: 'fa fa-fw fa-book',
            routerLink: ['demand-response/reports'],
            routerLinkActiveOptions: '[\'router-link-active\']'
          }
        ]
      });
      if (!this.coiService.isTecoTenant() && !this.coiService.isNypaTenant()) {
        items.push({
          label: 'Energy Efficiency',
          items: [
            /*{
              label: 'Registered Capacity',
              icon: 'fa fa-fw fa-bolt',
              routerLink: ['energy-efficiency/registered-capacity'],
              routerLinkActiveOptions: '[\'router-link-active\']'
            },*/
            {
              label: 'Asset Registry',
              icon: 'fa fa-fw fa-list',
              routerLink: ['asset-registry'],
              routerLinkActiveOptions: '[\'router-link-active\']',
              queryParams: {program: 2}
            }/*,
              {
                label: 'Performance Graph',
                icon: 'fa fa-fw fa-line-chart',
                routerLink: ['energy-efficiency/energy-graph'],
                routerLinkActiveOptions: '[\'router-link-active\']'
              }*/
          ]
        });
      }
      items.push({
        label: 'Manage',
        items: [
          {
            label: 'Accounts',
            icon: 'fa fa-fw fa-address-book',
            routerLink: ['manage/accounts'],
            routerLinkActiveOptions: '[\'router-link-active\']'
          },
          {
            label: 'Meters',
            icon: 'fa fa-fw fa-address-book',
            routerLink: ['manage/meters'],
            routerLinkActiveOptions: '[\'router-link-active\']'
          },
          {
            label: 'Contacts',
            icon: 'fa fa-fw fa-address-book',
            routerLink: ['manage/contacts'],
            routerLinkActiveOptions: '[\'router-link-active\']'
          },
          {
            label: 'Programs',
            icon: 'fa fa-fw fa-book',
            routerLink: ['manage/programs'],
            routerLinkActiveOptions: '[\'router-link-active\']'
          },
          {
            label: 'Accounts Approval',
            icon: 'fa fa-fw fa-flag',
            routerLink: ['manage/accounts-approval'],
            routerLinkActiveOptions: '[\'router-link-active\']'
          },
          {
            label: 'Enrollment Approval',
            icon: 'fa fa-fw fa-flag',
            routerLink: ['manage/enrollment-approval'],
            routerLinkActiveOptions: '[\'router-link-active\']'
          },
          {
            label: 'Documents',
            icon: 'fa fa-fw fa-file-text',
            routerLink: ['manage/documents'],
            routerLinkActiveOptions: '[\'router-link-active\']'
          },
          {
            label: 'Notifications',
            icon: 'fa fa-fw fa-bell',
            routerLink: ['manage/notifications/dashboard'],
            routerLinkActiveOptions: '[\'router-link-active\']'
          }
        ]
      });
      if (this.isMobileMenu) {
        items.push({
          label: 'User',
          items: [
            {
              label: 'Profile',
              icon: 'fa fa-fw fa-user',
              routerLink: ['/utility/settings/profile'],
              routerLinkActiveOptions: '[\'router-link-active\']'
            },
            {
              label: 'User Management',
              icon: 'fa fa-fw fa-users',
              routerLink: ['/utility/admin/user'],
              routerLinkActiveOptions: '[\'router-link-active\']'
            },
            {
              label: 'User Access Management',
              icon: 'fa fa-fw fa-info-circle',
              routerLink: ['/utility/reports/user-access'],
              routerLinkActiveOptions: '[\'router-link-active\']'
            }
          ]
        },
        {
          label: 'Logout',
          routerLink: ['/users/logout'],
          routerLinkActiveOptions: '[\'router-link-active\']'
        });
      }
    } else {
      items = [
        {
          label: 'Dashboard',
          routerLink: ['/business/dashboard'],
          routerLinkActiveOptions: '[\'router-link-active\']'
        }];
      if (this.coiService.isTecoTenant() || this.coiService.isNypaTenant()) {
        items.push({
          label: 'Asset Registry',
          routerLink: ['/business/asset-registry'],
          routerLinkActiveOptions: '[\'router-link-active\']',
          queryParams: {
            program: 1,
            account_id: this.accountId
          }
        });
      } else {
        items.push({
          label: 'Asset Registry',
          routerLink: ['/business/asset-registry'],
          routerLinkActiveOptions: '[\'router-link-active\']',
          queryParams: {
            account_id: this.accountId
          }
        });
      }
      items.push({
        label: 'Real-Time Energy',
        routerLink: ['/business/energy/energy-graph'],
        routerLinkActiveOptions: '[\'router-link-active\']'
      },
      {
        label: 'Demand Response',
        items: [
          {
            label: 'Asset Registry',
            icon: 'fa fa-fw fa-list',
            routerLink: ['asset-registry'],
            routerLinkActiveOptions: '[\'router-link-active\']',
            queryParams: {
              program: 1,
              account_id: this.accountId
            }
          },
          {
            label: 'Carbon Reduction',
            icon: 'fa fa-fw fa-cloud',
            routerLink: ['/business/demand-response/carbon-reduction'],
            routerLinkActiveOptions: '[\'router-link-active\']'
          },
          {
            label: 'Credits',
            icon: 'fa fa-fw fa-credit-card',
            routerLink: ['/business/profile/enrollment'],
            routerLinkActiveOptions: '[\'router-link-active\']',
            queryParams: {programType: 1}
          },
          {
            label: 'Events',
            icon: 'fa fa-fw fa-calendar',
            routerLink: ['/business/demand-response/events'],
            routerLinkActiveOptions: '[\'router-link-active\']'
          },
          {
            label: 'Performance Graph',
            icon: 'fa fa-fw fa-line-chart',
            routerLink: ['/business/demand-response/performance-graph'],
            routerLinkActiveOptions: '[\'router-link-active\']'
          },
          {
            label: 'Reports',
            icon: 'fa fa-fw fa-book',
            routerLink: ['/business/demand-response/reports'],
            routerLinkActiveOptions: '[\'router-link-active\']'
          },
          {
            label: 'Revenue',
            icon: 'fa fa-fw fa-dollar',
            routerLink: ['/business/demand-response/revenue'],
            routerLinkActiveOptions: '[\'router-link-active\']'
          }
        ]
      });
      if (!this.coiService.isTecoTenant() && !this.coiService.isNypaTenant()) {
        items.push({
          label: 'Energy Efficiency',
          items: [
            {
              label: 'Asset Registry',
              icon: 'fa fa-fw fa-list',
              routerLink: ['asset-registry'],
              routerLinkActiveOptions: '[\'router-link-active\']',
              queryParams: {
                program: 2,
                account_id: this.accountId
              }
            },
            {
              label: 'Bill Forecast',
              icon: 'fa fa-fw fa-line-chart',
              routerLink: ['energy-efficiency/bill-forecast'],
              routerLinkActiveOptions: '[\'router-link-active\']'
            },
            /*{
              label: 'Carbon Reduction',
              icon: 'fa fa-fw fa-cloud',
              routerLink: ['/business/energy-efficiency/carbon-reduction'],
              routerLinkActiveOptions: '[\'router-link-active\']'
            },*/
            {
              label: 'Credits',
              icon: 'fa fa-fw fa-credit-card',
              routerLink: ['/business/profile/enrollment'],
              routerLinkActiveOptions: '[\'router-link-active\']',
              queryParams: {programType: 2}
            },
            /*{
              label: 'Performance Graph',
              icon: 'fa fa-fw fa-line-chart',
              routerLink: ['/business/energy-efficiency/energy-graph'],
              routerLinkActiveOptions: '[\'router-link-active\']'
            },*/
            /*{
              label: 'Revenue',
              icon: 'fa fa-fw fa-dollar',
              routerLink: ['/business/energy-efficiency/revenue'],
              routerLinkActiveOptions: '[\'router-link-active\']'
            },*/
          ]
        });
      }
      if (!this.coiService.isTecoTenant() && !this.coiService.isNypaTenant()) {
        items.push({
          label: 'Carbon Footprint',
          items: [
            {
              label: 'Total',
              icon: 'fa fa-fw fa-recycle',
              routerLink: ['/business/carbon-footprint/total'],
              routerLinkActiveOptions: '[\'router-link-active\']'
            },
            {
              label: 'Real-Time Emissions',
              icon: 'fa fa-fw fa-line-chart',
              routerLink: ['/business/carbon-footprint/real-time-emissions'],
              routerLinkActiveOptions: '[\'router-link-active\']'
            },
            {
              label: 'Offsets',
              icon: 'fa fa-fw fa-cloud',
              routerLinkActiveOptions: '[\'router-link-active\']',
              items: [
                {
                  label: 'Demand Response',
                  routerLink: ['/business/demand-response/carbon-reduction'],
                  routerLinkActiveOptions: '[\'router-link-active\']'
                },
                {
                  label: 'Energy Efficiency',
                  visible: !this.coiService.isTecoTenant() && !this.coiService.isNypaTenant(),
                  routerLink: ['/business/energy-efficiency/carbon-reduction'],
                  routerLinkActiveOptions: '[\'router-link-active\']',
                  disabled: true
                },
                {
                  label: 'Renewable Energy',
                  visible: !this.coiService.isTecoTenant() && !this.coiService.isNypaTenant(),
                  routerLink: ['/renewable-energy'],
                  routerLinkActiveOptions: '[\'router-link-active\']',
                  disabled: true
                }
              ]
            },
            {
              label: 'Get Certified',
              icon: 'fa fa-fw fa-graduation-cap',
              url: 'https://www.greenbusinesspartnership.org/membership-info',
              target: '_blank'
            },
          ]
        });
      }
      if (!this.coiService.isNypaTenant() && !this.environment.production) {
        items.push({
          label: 'Impact',
          items: [
            {
              label: 'kW for Good',
              icon: 'fa fa-fw fa-heart',
              routerLink: ['/business/impact/kw-for-good'],
              routerLinkActiveOptions: '[\'router-link-active\']',
              visible: true
            }
          ]
        });
      }
      items.push({
        label: 'Programs',
        items: [
          {
            label: 'Demand Response',
            icon: 'fa fa-fw fa-bolt',
            routerLink: ['/business/programs/demand-response'],
            routerLinkActiveOptions: '[\'router-link-active\']',
            visible: false
          },
          {
            label: 'Enrollment',
            icon: 'fa fa-fw fa-user',
            routerLink: ['/business/profile/enrollment'],
            routerLinkActiveOptions: '[\'router-link-active\']'
          }
        ]
      });
      
      if (!this.coiService.isTecoTenant() && !this.coiService.isNypaTenant() ){
      // && (this.coiService.getUserInfo().user_id === 178 || this.coiService.getUserInfo().user_id === 384 || this.coiService.getUserInfo().user_id === 43 || this.coiService.getUserInfo().user_id === 13)) {
        items.push({
          label: 'Demand Management',
          items: [
            {
              label: 'Threshold',
              icon: 'fa fa-fw fa-list',
              routerLink: ['/business/demand-management/threshold-management'],
              routerLinkActiveOptions: '[\'router-link-active\']',
              visible: true
            },
            {
              label: 'Demand Forecasting',
              icon: 'fa fa-fw fa-line-chart',
              routerLink: ['/business/demand-management/demand-forecasting'],
              routerLinkActiveOptions: '[\'router-link-active\']',
              visible: true
            }
          ]
        });
      }
      if (this.isMobileMenu) {
        items.push({
          label: 'User',
          items: [
            {
              label: 'Profile',
              icon: 'fa fa-fw fa-user',
              routerLink: ['/business/settings/profile'],
              routerLinkActiveOptions: '[\'router-link-active\']'
            },
            {
              label: 'Company',
              icon: 'fa fa-fw fa-building',
              routerLink: ['/users/business'],
              routerLinkActiveOptions: '[\'router-link-active\']'
            }
          ]
        },
        {
          label: 'Logout',
          routerLink: ['/users/logout'],
          routerLinkActiveOptions: '[\'router-link-active\']'
        });
      }
    }
    this.items = items;
  }

}
